import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueSimpleMarkdown from "vue-simple-markdown";
import "vue-simple-markdown/dist/vue-simple-markdown.css";

Vue.use(VueSimpleMarkdown);

Vue.config.productionTip = false;

Vue.prototype.$projects = [];

router.afterEach((to, from) => {
  App.data().showNav = false;
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
